// extracted by mini-css-extract-plugin
export default {"tabsContainer":"tabsNav_tabsContainer__YvvMz","tab":"tabsNav_tab__U1bNL","active":"tabsNav_active__iHuDL"};